
import { ProductSetInfoKey, ProductSetInfoKeyDataType } from '@/__generated__/globalTypes'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { validationMixin } from 'vuelidate'
import { FieldInformation } from './types'

@Component({
  name: 'NumberField',
  mixins: [validationMixin]
})
export default class NumberField extends Vue {
  @Prop({ required: true }) readonly id!: string
  @Prop({ required: true }) readonly isOptional!: boolean
  @Prop({ required: true }) readonly productSetInfoKey!: ProductSetInfoKey
  @Prop({ required: true }) value!: FieldInformation
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ required: true }) v!: any
  @Prop({ required: true }) disabled!: boolean

  mounted() {
    this.validates()
  }

  onValueChange(inputValue: string) {
    this.validates()

    this.$emit('input', {
      item1: this.id,
      item2: inputValue,
      isOptional: this.isOptional,
      dataType: ProductSetInfoKeyDataType.Number
    } as FieldInformation)
  }

  get getErrors() {
    const errors = new Array<string>()
    if (!this.v.item2.$dirty) {
      return errors
    }
    if (!this.v.item2.money) {
      errors.push(`${this.getLabelText()} ${this.$t('global.validationMoney')}`)
    }
    if (!this.v.item2.required) {
      errors.push(`${this.getLabelText()} ${this.$t('global.validationRequired')}`)
    }
    return errors
  }

  validates() {
    this.v.item2.$touch()
  }

  getLabelText() {
    return this.$t(`projectDesignPackage.labels.restrictionKeys.${this.productSetInfoKey.key}`)
  }
}
